const theme = {
  blockStyles: {
    audio_blocks: {
      colourPrimary: '#ce0000',
      colourSecondary: '#950000',
      colourTertiary: '#f60000'
    },
    led_blocks: {
      colourPrimary: '#ff3059',
      colourSecondary: '#d83059',
      colourTertiary: '#ff5c76'
    },
    display_blocks: {
      colourPrimary: '#fc764c',
      colourSecondary: '#dd624f',
      colourTertiary: '#fca255'
    },
    motor_blocks: {
      colourPrimary: '#fdb918',
      colourSecondary: '#fd9e2c',
      colourTertiary: '#fdd81d'
    },
    sensor_blocks: {
      colourPrimary: '#63cb38',
      colourSecondary: '#63ab37',
      colourTertiary: '#8ee52d'
    },
    start_blocks: {
      colourPrimary: '#01ADFF',
      colourSecondary: '#018AFF',
      colourTertiary: '#01CEFF'
    },
    loop_blocks: {
      colourPrimary: '#26CCDF',
      colourSecondary: '#10AEEB',
      colourTertiary: '#26E4DF'
    },
    logic_blocks: {
      colourPrimary: '#3366FF',
      colourSecondary: '#334AFF',
      colourTertiary: '#337FFF'
    },
    math_blocks: {
      colourPrimary: '#9999FF',
      colourSecondary: '#9962FF',
      colourTertiary: '#99AFFF'
    },
    list_blocks: {
      colourPrimary: '#9944CC',
      colourSecondary: '#8C1ACC',
      colourTertiary: '#996BCC'
    },
    text_blocks: {
      colourPrimary: '#FF66B1',
      colourSecondary: '#FF3EB1',
      colourTertiary: '#FF90B1'
    },
    ifzero_blocks: {
      colourPrimary: '#F0007D',
      colourSecondary: '#CC007D',
      colourTertiary: '#F0427D'
    },
    ifline_blocks: {
      colourPrimary: '#FF5733',
      colourSecondary: '#EF3733',
      colourTertiary: '#FF8D33'
    },
    variable_blocks: {
      colourPrimary: '#FFB400',
      colourSecondary: '#FF9600',
      colourTertiary: '#FFCF00'
    },
    procedure_blocks: {
      colourPrimary: '#3be866',
      colourSecondary: '#6EDE97',
      colourTertiary: '#B9EAAA'
    }
  },
  categoryStyles: {
    audio_category: {
      colour: '#ce0000'
    },
    led_category: {
      colour: '#ff3059'
    },
    display_category: {
      colour: '#fc764c'
    },
    motor_category: {
      colour: '#fdb918'
    },
    sensor_category: {
      colour: '#63cb38'
    },
    start_category: {
      colour: '#01ADFF'
    },
    control_category: {
      colour: '#26CCDF'
    },
    logic_category: {
      colour: '#3366FF'
    },
    math_category: {
      colour: '#9999FF'
    },
    list_category: {
      colour: '#9944CC'
    },
    text_category: {
      colour: '#FF66B1'
    },
    ifzero_category: {
      colour: '#F0007D'
    },
    ifline_category: {
      colour: '#FF5733'
    },
    variable_category: {
      colour: '#FFB400'
    },
    procedures_category: {
      colour: '#3be866'
    }
  },
  fontStyle: {
    family: `'PingFang SC','Microsoft YaHei','\\5FAE\\8F6F\\96C5\\9ED1','Hiragino Sans GB','Helvetica Neue','Helvetica','Arial','sans-serif'`,
    weight: '500',
    size: '11'
  },
  // componentStyles: {
  //   workspaceBackgroundColour: '#1e1e1e'
  // },
  startHats: true
}
export default theme
